import { render, staticRenderFns } from "./Benp01Modal.vue?vue&type=template&id=0d92e19c&scoped=true&"
import script from "./Benp01Modal.vue?vue&type=script&lang=ts&"
export * from "./Benp01Modal.vue?vue&type=script&lang=ts&"
import style0 from "./Benp01Modal.vue?vue&type=style&index=0&id=0d92e19c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92e19c",
  null
  
)

export default component.exports